import React, { useEffect } from "react";
import { composeMatchStatus, periodTypes, statusTypes } from "../../mls-match-list/utils";
import useMLSMatch from "../../mls-match-list/hooks/useMLSMatch";

export const actionTypes = {
  status: 'status',
  matchSportecId: "matchSportecId"
};

export function matchStatusReducer(state, action) {
  switch (action.type) {
    case actionTypes.status: {
      return { ...state, status: action.payload };
    }
    case actionTypes.matchSportecId: {
      return { ...state, matchSportecId: action.payload };
    }

    default: {
      throw new Error(`Unsupported type: ${action.type}`);
    }
  }
}

export function useMatchStatus({ matchData = null, useMatchData, initialState, reducer = matchStatusReducer } = {}) {
  const { current: currentState } = React.useRef(initialState);
  const [state, dispatch] = React.useReducer(reducer, currentState);

  const { status: matchStatus, matchSportecId, matchStatusOverride } = state || {};

  const updateMatchStatus = React.useCallback(({ type, payload }) => dispatch({ type, payload }), [dispatch]);

  const status = matchStatusOverride?.abbreviation ? matchStatusOverride : matchStatus;

  const isQueryDisabled = useMatchData && matchData && status?.abbreviation !== statusTypes.live;

  const queryConfig = status
    ? {
      enabled: isQueryDisabled ? false : true,
      refetchIntervalInBackground: true,
      retry: false,
      staleTime:
        status?.abbreviation === statusTypes.live || status?.abbreviation === statusTypes.pre
          ? 30000
          : Infinity,
      refetchInterval:
        status?.abbreviation === statusTypes.live
          ? 30000
          : status?.abbreviation === statusTypes.pre
            ? 200000
            : null
    }
    : { enabled: isQueryDisabled ? false : true };

  const { data, error, isLoading, isError, isIdle } = useMLSMatch({
    matchSportecId, options: { ...queryConfig, enabled: !!matchSportecId }
  });

  const mlsMatch = matchData ? matchData : data;

  useEffect(() => {
    if (!mlsMatch) {
      return;
    }
    const { match_status } = mlsMatch.match_information || {};
    const { delayedMatch } = initialState;

    const matchStatus = matchStatusOverride
      ? matchStatusOverride
      : composeMatchStatus({ period: match_status, delayedMatch });

    updateMatchStatus({ type: actionTypes.status, payload: matchStatus });
  }, [mlsMatch, initialState.delayedMatch]);

  const isShootout = status?.value === periodTypes.ShootOut;


  return {
    statsAPIMatch: mlsMatch,
    mlsMatch,
    error,
    isLoading,
    isIdle,
    isError,
    status,
    isShootout,
    queryConfig,
    updateMatchStatus
  };
}
